import { OFFLINE_PRIME_OFFER_REPORTS_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  offline_prime_offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
  role: {
    message: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OFFLINE_PRIME_OFFER_REPORTS_FETCHED_SUCCESS:
      return {
        ...state,
        OfflinePrimeOffer: action.payload.OfflinePrimeOffer,
        pager: action.payload.pager,
      };

    default:
      return state;
  }
};
